// Email notification configuration
// Set up EmailJS at https://www.emailjs.com/
// Configure these values in your .env file (see .env.example)

export const EMAIL_CONFIG = {
  // Your EmailJS Public Key (found in EmailJS dashboard → Account → General)
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
  
  // Your EmailJS Service ID (found after creating an email service)
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
  
  // Your EmailJS Template ID (found after creating an email template)
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
  
  // Your email address to receive notifications
  NOTIFICATION_EMAIL: process.env.REACT_APP_NOTIFICATION_EMAIL || '',
  
  // Enable/disable email notifications (set to 'false' in .env to disable)
  ENABLED: process.env.REACT_APP_EMAIL_NOTIFICATIONS_ENABLED !== 'false',
};

